import './index.scss';
import React, {Component, PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import RgaSearchModel from '../../search/state/rga-search-model';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import UsefulLinksPanel from '../../search/components/useful-links-panel';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function handleOnMassUpdate() {

    this.actions.openMassUpdateModal();

}

function handleOnMassUpload() {

    this.actions.openMassUploadModal();

}

function handleFileDownloadSuccess() {

    this.actions.downloadRgaTemplate();

}

function handleUpload() {

    this.props.actions.uploadRgaExcel(this.state.selectedFiles[0]);

}

class MassUpload extends Component {
    state = {
        files: [],
        searchFields: {
            analysts: '',
            rgaNumbers: '',
            warrantyClaims: ''
        },
        selectedFiles: []
    };

    componentWillUnmount() {

        this.setState({selectedFiles: []});

    }

    render() {

        return (
            <section className='mass-upload'>

                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='rga-homepage-aside'>
                    <UsefulLinksPanel
                        onMassUpdate={this.props::handleOnMassUpdate}
                        onMassUpload={this.props::handleOnMassUpload}
                        security={this.props.security}
                    />
                </aside>
                <main className='rga-homepage-home-main'>
                    <h3>{'RGA Upload'}</h3>

                    <div>
                        <section className='button-group recalled-button-group rga-download-button'>
                            <button
                                className='primary'
                                onClick={handleFileDownloadSuccess.bind(this.props)}
                            >
                                <FormattedMessage id='Download Template'/>
                            </button>
                        </section>
                        <div className='rga-notes'>
                            <h4><b>{'Notes :'}</b></h4>
                            <p>{'Please ensure the RGAs are uploaded using the designated template.The file format must be .xlsx'}</p>

                        </div>
                    </div>
                    <div className='file-upload-section'>
                        <input
                            className='fileUpload'
                            onChange={event => {

                                const file = event.target.files[0];

                                if (file) {

                                    this.setState({selectedFiles: [...this.state.selectedFiles, file]});

                                }

                            }}
                            type='file'
                        />
                        <section className='button-group recalled-button-group rga-upload-button'>
                            <button
                                className='primary'
                                onClick={handleUpload.bind(this)}
                            >
                                <FormattedMessage id='Upload File'/>
                            </button>
                        </section>
                    </div>
                    <div className='rga-notes-upload'>
                        <p>{'Upon successful upload, a confirmation report will be automatically downloads, include the RGA numbers assigned to each request.'}</p>
                    </div>
                </main>
            </section>
        );

    }
}

MassUpload.displayName = 'MassUpload';
MassUpload.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    rgaSearchModel: PropTypes.instanceOf(RgaSearchModel).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default MassUpload;



// WEBPACK FOOTER //
// ./src/rga/mass-upload/components/index.js